module.exports = __webpack_public_path__ + "static/media/step2.680028d2.png";